import { useEffect } from 'react';
import { PROGRESS_CACHE_PREFIX, useCachedQuery } from '@/shared/lib/useCachedQuery';
import { getStreak } from '../api/streakApi';

/** Под `PROGRESS_CACHE_PREFIX` — сбрасывается выходом из чата вместе с остальной статистикой. */
export const STREAK_CACHE_KEY = `${PROGRESS_CACHE_PREFIX}streak`;

/**
 * Последний пульс таймера уходит при размонтировании чата — уже после того,
 * как главная смонтировалась и запросила стрик. `invalidateCache` смонтированный
 * хук не будит, поэтому таймер зовёт `notifyStreakChanged`, и хук перечитывает сам.
 */
const listeners = new Set<() => void>();

export function notifyStreakChanged(): void {
  for (const listener of listeners) listener();
}

export function useStreak() {
  const { data, error, isLoading, reload } = useCachedQuery(STREAK_CACHE_KEY, () => getStreak());

  useEffect(() => {
    listeners.add(reload);
    return () => {
      listeners.delete(reload);
    };
  }, [reload]);

  return { streak: data, error: isLoading ? null : error, isLoading, reload };
}
